import { gql } from "@apollo/client";

export const GET_ADVERTISE = gql`
query Query($page: Int, $limit: Int,$sort: userSort) {
  getBlogs(page: $page, limit: $limit,sort: $sort) {
    count
    data {
      id
      title
      image
      description
      readStatus
      isActive
      createdAt
    }
  }
}
`

export const UPDATE_NOTIFICATION_STATUS = gql`
mutation Mutation($id: [ID]) {
  updateReadStatus(id: $id)
}
`

export const CALCULATE_INTERNATIONAL = gql`
query CalculateRate($country: String!, $originPincode: String!, $destinationPincode: String!, $weight: Float!, $itemType: String!, $state: String) {
  calculateRate(country: $country, originPincode: $originPincode, destinationPincode: $destinationPincode, weight: $weight, itemType: $itemType, state: $state) {
    country
    zone
    weight
    price
  }
}
`
export const UPLOAD_RATES_MUTATION = gql`
  mutation UploadRates($file: Upload!) {
    uploadRates(file: $file) {
      success
      message
      uploadedCount
      errors
    }
  }
`;

export const CALCULATE_RATE = gql`
  query CalculateRate(
    $country: String!
    $state: String
    $originPincode: String
    $destinationPincode: String
    $weight: Float!
    $itemType: String!
  ) {
    calculateRate(
      country: $country
      state: $state
      originPincode: $originPincode
      destinationPincode: $destinationPincode
      weight: $weight
      itemType: $itemType
    ) {
      serviceType
      rate
      businessDays
      instructions
    }
  }
`;

export const GET_AVAILABLE_WEIGHTS = gql`
query GetAvailableWeights($country: String!, $itemType: String!) {
  getAvailableWeights(country: $country, itemType: $itemType)
}

`

export const GET_AVAILABLE_COUNTRIES = gql`
 query GetAvailableCountries($itemType: String) {
    getAvailableCountries(itemType: $itemType) {
        value
        label
        needsPincode
    }
}
`;

export const TRACK_SHIPMENT = gql`
  query TrackShipment($trackingNumber: String!) {
    trackShipment(trackingNumber: $trackingNumber) {
      courier
      trackingNumber
      data
    }
  }
`;

export const GET_TRACKING_DOMESTIC = gql`
query TrackShipmentDomestic($awb: String!) {
  trackShipmentDomestic(awb: $awb) {
    awb
    current_status
    delivered_at
    consignee_name
    consignee_phone
    forwardingNumber
    courier
    data
    transit_history {
      event_time
      location
      status_code
      remarks
      status
    }
    last_center_details
    proof_of_delivery
    order {
    createdAt
      franciseId {
        fullName
        email
        contactNo
        alternateContactNo
        officeAddress
        officePincode
        officeCity
        officeState
        officeMainArea
        officeTelephoneNo
        district
      }
    }
  }
}
`